export default __webpack_public_path__ + "5cd379f7e3297d89e0a280c2392756ac.png";